import makeStyles from '@mui/styles/makeStyles';

export const rowStyles = makeStyles((theme) => ({
  row: {
    fontSize: 13,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  col: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
  colText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: '100%',
  },
  colTextFirst: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
    marginTop: '28px',
  },
  link: {
    color: theme.colors.blue,
  },
  centerCol: {
    justifyContent: 'center',
  },
  listRow: {
    cursor: 'pointer',
  },
  flexRow: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'row',
  },
  rowBg: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  headerRow: {
    borderBottom: `1px solid ${theme.colors.darkGrey}`,
  },
  checkbox: {
    width: 36,
    display: 'flex',
    alignItems: 'center',
  },
  accessIcon: {
    marginRight: 5,
  },
}));

export const modalStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowIcon: {
    padding: 9,
  },
  selectable: {
    cursor: 'pointer',
  },
  grayBG: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  title: {
    padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
  },
  sceneTitle: {
    fontWeight: 'bold',
  },
  sceneText: {
    margin: theme.spacing(1),
  },
}));

export default makeStyles((theme) => ({
  selectedContainer: {
    margin: `0 ${theme.spacing(1)}`,
  },
  selectedText: {
    fontSize: 13,
    fontWeight: 'bold',
    fontStyle: 'italic',
    padding: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(1),

    '& button': {
      backgroundColor: theme.colors.blue,
      marginRight: theme.spacing(1),
      color: theme.colors.white,

      '&:first-child': {
        backgroundColor: theme.colors.black,
      },

      '&.accessButton': {
        backgroundColor: theme.colors.blue,
      },
    },
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',

    '& .MuiInputBase-root': {
      width: '100%',
    },
    '& .MuiFormGroup-root': {
      backgroundColor: theme.palette.action.disabled,
      width: '85%',
      marginTop: theme.spacing(3),
      padding: `0 ${theme.spacing(1)}`,
    },
  },

  modalContent: {
    padding: theme.spacing(4),
  },
  modalTitle: {
    fontWeight: 'bold',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  nameRow: {
    margin: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  centerLoader: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },

  barTitle: {
    textAlign: 'center',
    width: '100%',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileContainer: {
    position: 'relative',
    top: 64,
  },
}));
